/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FolderShared16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M5.846 3C6.923 3 6.654 4.048 8 4.048h5.385c.892 0 1.615.703 1.615 1.571v6.81c0 .867-.723 1.571-1.615 1.571H2.615C1.723 14 1 13.296 1 12.429V4.57C1 3.704 1.723 3 2.615 3h3.231zm3.77 6.81c-.602 0-1.042.285-1.313.735a3.16 3.16 0 01.223.758.942.942 0 01-.09.596.874.874 0 00.105.006h2.155l.11-.007c.315-.04.46-.255.42-.514a2.58 2.58 0 00-.14-.522c-.244-.629-.736-1.052-1.47-1.052zm-3.231 0c-.735 0-1.227.423-1.471 1.053a2.496 2.496 0 00-.139.522c-.045.283.139.52.534.52h2.155l.111-.007c.315-.04.46-.255.419-.514a2.516 2.516 0 00-.14-.522c-.243-.629-.735-1.052-1.47-1.052zm3.231-2.096a.797.797 0 00-.808.786c0 .434.362.786.808.786a.797.797 0 00.808-.786.797.797 0 00-.808-.786zm-3.231 0a.797.797 0 00-.808.786c0 .434.362.786.808.786a.797.797 0 00.807-.786.797.797 0 00-.807-.786z"
        />
    </AccessibleSVG>
);

export default FolderShared16;
